export default {
    STANDARD: 'direction-standard',
    REVERSE: 'direction-reverse',
};
//# sourceMappingURL=directions.js.map